import React from 'react';
import { Navbar } from '../components/Navbar';
import { Hero } from '../components/Hero';
import { Features } from '../components/Features';
import { Industries } from '../components/Industries';
import { Platform } from '../components/Platform';
import { FAQ } from '../components/FAQ';
import { CTA } from '../components/CTA';
export function LandingPage() {
  return <div className="min-h-screen bg-white font-sans selection:bg-blue-900 selection:text-white" data-id="element-244">
      <Navbar data-id="element-245" />
      <main data-id="element-246">
        <Hero data-id="element-247" />
        <Features data-id="element-248" />
        <Industries data-id="element-249" />
        <Platform data-id="element-250" />
        <FAQ data-id="element-251" />
        <CTA data-id="element-252" />

        {/* Simple Footer for completeness */}
        <footer className="bg-gray-100 py-12 border-t border-gray-200" data-id="element-253">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-254">
            <div className="flex items-center gap-2" data-id="element-255">
              <div className="w-6 h-6 bg-blue-950 rounded flex items-center justify-center" data-id="element-256">
                <span className="text-white font-bold text-xs" data-id="element-257">S</span>
              </div>
              <span className="font-bold text-gray-900" data-id="element-258">ScanMind</span>
            </div>
            <div className="text-sm text-gray-500" data-id="element-259">
              © 2024 ScanMind AI. Все права защищены.
            </div>
            <div className="flex gap-6" data-id="element-260">
              <a href="#" className="text-gray-500 hover:text-gray-900 text-sm" data-id="element-261">
                Конфиденциальность
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-900 text-sm" data-id="element-262">
                Условия
              </a>
              <a href="#" className="text-gray-500 hover:text-gray-900 text-sm" data-id="element-263">
                Telegram
              </a>
            </div>
          </div>
        </footer>
      </main>
    </div>;
}